(() => {
  'use strict';
  const drawer = document.getElementById('GainrCartDrawer');
  if (!drawer || typeof drawer.showModal !== 'function' || !window.fetch) return;
  const content = drawer.querySelector('[data-cart-content]');
  const status = drawer.querySelector('[data-cart-status]');
  const live = document.querySelector('[data-shop-status]');
  const text = drawer.dataset;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  let busy = false;
  let opener;
  let closing = false;
  let closeTimer;


  function syncOffer(form) {
    const offers = form?.querySelector('[data-pot-offers]');
    if (!offers) return;
    const pending = offers.querySelector('input[value="2"]')?.checked && offers.dataset.duoActive !== 'true';
    const button = form.querySelector('button[name="add"]');
    if (button) button.disabled = Boolean(pending);
  }
  document.querySelectorAll('[data-duo-enabled]').forEach(input => { input.disabled = false; syncOffer(input.form); });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-pot-offers] input[name="quantity"]')) syncOffer(event.target.form);
  });

  function announce(message, error = false) {
    status.textContent = message;
    status.classList.toggle('is-error', error);
    if (live) live.textContent = message;
  }
  function open(trigger) {
    clearTimeout(closeTimer);
    closing = false;
    drawer.classList.remove('is-closing');
    if (!drawer.open) {
      opener = trigger?.closest('.mobile-nav')?.querySelector('summary') || trigger;
      drawer.showModal();
      document.body.classList.add('cart-is-open');
      drawer.querySelector('[data-cart-close]').focus();
    }
  }
  function close() {
    if (!drawer.open || closing) return;
    closing = true;
    drawer.classList.add('is-closing');
    closeTimer = setTimeout(() => drawer.close(), reduce.matches ? 0 : 240);
  }
  drawer.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
  drawer.addEventListener('close', () => {
    closing = false;
    drawer.classList.remove('is-closing');
    document.body.classList.remove('cart-is-open');
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  });
  function lock(value) {
    busy = value;
    content.setAttribute('aria-busy', String(value));
    content.querySelectorAll('button,input').forEach((control) => { control.disabled = value; });
  }
  async function request(url, options = {}) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(url, { ...options, credentials: 'same-origin', cache: 'no-store', signal: controller.signal, headers: { Accept: 'application/json', ...options.headers } });
      const data = await response.json();
      if (!response.ok || (data.status && Number(data.status) >= 400)) {
        const error = new Error(typeof data.description === 'string' ? data.description : text.error);
        error.confirmed = true;
        throw error;
      }
      return data;
    } finally { clearTimeout(timeout); }
  }
  function render(html) {
    if (typeof html !== 'string') return false;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const body = parsed.querySelector('[data-cart-rendered]');
    if (!body) return false;
    content.replaceChildren(body);
    const count = Number(body.dataset.count) || 0;
    document.querySelectorAll('[data-cart-open]').forEach((link) => {
      link.setAttribute('aria-label', `${text.cartLabel} (${count})`);
      const badge = link.querySelector('[data-cart-count]');
      if (badge) { badge.textContent = String(count); badge.hidden = count === 0; }
    });
    return true;
  }
  async function refresh() {
    const url = new URL(text.rootUrl, location.origin);
    url.searchParams.set('sections', 'cart-drawer');
    const sections = await request(url);
    if (!render(sections['cart-drawer'])) throw new Error(text.loadError);
  }
  async function showCart(trigger) {
    if (busy) return;
    open(trigger);
    lock(true);
    announce(text.loading);
    try { await refresh(); announce(''); }
    catch (_) { announce(text.loadError, true); }
    finally { lock(false); }
  }
  async function mutate(url, payload, trigger, isAdd, restore) {
    if (busy) return;
    lock(true);
    const wasDisabled = trigger?.disabled;
    if (trigger) { trigger.setAttribute('aria-busy', 'true'); trigger.classList.add('is-loading'); if ('disabled' in trigger) trigger.disabled = true; }
    announce(isAdd ? text.adding : text.loading);
    const formData = payload instanceof FormData;
    if (formData) { payload.set('sections', 'cart-drawer'); payload.set('sections_url', text.rootUrl); payload.delete('return_to'); }
    else { payload.sections = 'cart-drawer'; payload.sections_url = text.rootUrl; }
    try {
      const data = await request(url, { method: 'POST', headers: formData ? {} : { 'Content-Type': 'application/json' }, body: formData ? payload : JSON.stringify(payload) });
      if (!render(data.sections?.['cart-drawer'])) await refresh();
      if (isAdd) open(trigger);
      announce(isAdd ? text.added : text.updated);
      lock(false);
      if (restore && drawer.open) {
        const row = Array.from(content.querySelectorAll('[data-line-key]')).find((node) => node.dataset.lineKey === restore.key);
        const target = row?.querySelector(restore.selector) || status;
        target.focus({ preventScroll: true });
      }
      document.querySelectorAll('[data-cart-open]').forEach((link) => {
        link.classList.remove('cart-pulse');
        requestAnimationFrame(() => link.classList.add('cart-pulse'));
      });
    } catch (error) {
      open(trigger);
      announce(error.confirmed ? error.message : text.error, true);
      status.focus({ preventScroll: true });
    } finally {
      lock(false);
      if (trigger?.isConnected) { trigger.removeAttribute('aria-busy'); trigger.classList.remove('is-loading'); if ('disabled' in trigger) trigger.disabled = Boolean(wasDisabled); }
    }
  }
  function change(form, quantity, selector) {
    if (!Number.isInteger(quantity) || quantity < 0 || busy) return;
    const input = form.querySelector('input[name="quantity"]');
    const maximum = input.max === '' ? Infinity : Number(input.max);
    if (quantity > maximum) { input.setCustomValidity(`Maximum : ${maximum}`); input.reportValidity(); input.setCustomValidity(''); return; }
    if (quantity > 0 && quantity < Number(form.dataset.min)) quantity = Number(form.dataset.min);
    return mutate(text.cartChange, { id: form.dataset.key, quantity }, null, false, { key: form.dataset.key, selector });
  }
  document.addEventListener('click', (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const cartLink = event.target.closest('[data-cart-open]');
    const quick = event.target.closest('[data-quick-add]');
    if (cartLink) { event.preventDefault(); showCart(cartLink); }
    else if (quick) {
      event.preventDefault();
      if (!busy) mutate(text.cartAdd, { items: [{ id: quick.dataset.quickAdd, quantity: Number(quick.dataset.quantity) || 1 }] }, quick, true);
    }
    if (event.target.closest('[data-cart-close]')) close();
    if (event.target === drawer) {
      const box = drawer.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close();
    }
    const removeButton = event.target.closest('[data-cart-remove]');
    if (removeButton) change(removeButton.closest('form'), 0, 'input[name="quantity"]');
    const stepButton = event.target.closest('[data-quantity-step]');
    if (stepButton) {
      const form = stepButton.closest('form');
      const input = form.querySelector('input[name="quantity"]');
      const direction = Number(stepButton.dataset.quantityStep);
      let quantity = Number(input.value) + direction * (Number(input.step) || 1);
      if (direction < 0 && quantity < Number(form.dataset.min)) quantity = 0;
      change(form, Math.max(0, quantity), `[data-quantity-step="${direction}"]`);
    }
  });
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form.matches('.purchase-form')) {
      if (event.submitter && event.submitter.name !== 'add') return;
      event.preventDefault();
      if (!busy && form.checkValidity() && form.querySelector('[name="id"]')?.value && !form.querySelector('button[type="submit"]')?.disabled) mutate(text.cartAdd, new FormData(form), event.submitter, true);
    } else if (form.matches('.drawer-quantity-form')) {
      event.preventDefault();
      const quantity = Number(form.querySelector('input[name="quantity"]').value);
      change(form, quantity, 'input[name="quantity"]');
    } else if (drawer.contains(form) && busy) event.preventDefault();
  });
  drawer.addEventListener('change', (event) => {
    if (event.target.matches('input[name="quantity"]') && event.target.checkValidity()) change(event.target.form, Number(event.target.value), 'input[name="quantity"]');
  });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) { drawer.close(); refresh().catch(() => {}); }
  });
})();
